import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";

const BASE_VEHICLES = "access-control-service/vehicles";

const RESOURCES = {
  LIST_CONDO_USER_VEHICLE: (id) => `${BASE_VEHICLES}/condo-users/${id}`,
  DELETE_VEHICLE: (id) => `${BASE_VEHICLES}/${id}`,
  UPDATE_VEHICLE: (id) => `${BASE_VEHICLES}/${id}`,
};

class VehiclesService {
  static async listVehiclesByCondoUser(condoUserId) {
    try {
      return await axios.get(RESOURCES.LIST_CONDO_USER_VEHICLE(condoUserId));
    } catch (error) {
      console.log(error);
      ResponseAlerts({
        response: error.response,
        errorMessage: "Erro ao listar veículos do usuário",
      });
      return error.response;
    }
  }

  static async createVehicle(payload) {
    try {
      const response = await axios.post(BASE_VEHICLES, payload);
      ResponseAlerts({
        response: response,
        successMessage: "Veículo cadastrado com sucesso",
      });
      return response;
    } catch (error) {
      console.log(error);
      ResponseAlerts({
        response: error.response,
        errorMessage: "Erro ao cadastrar veículo",
      });
      return error.response;
    }
  }

  static async deleteVehicle(id) {
    try {
      const response = await axios.delete(RESOURCES.DELETE_VEHICLE(id));
      ResponseAlerts({
        response: response,
        successMessage: "Veículo excluído com sucesso",
      });
      return response;
    } catch (error) {
      console.log(error);
      ResponseAlerts({
        response: error.response,
        errorMessage: "Erro ao excluir veículo",
      });
      return error.response;
    }
  }

  static async updateVehicle(id, payload) {
    return await axios
      .put(RESOURCES.UPDATE_VEHICLE(id), payload)
      .then((response) => {
        ResponseAlerts({
          response: response,
          successMessage: "Veículo atualizado com sucesso",
        });
        return response;
      })
      .catch((error) => {
        console.log(error);
        ResponseAlerts({
          response: error.response,
          errorMessage: "Erro ao atualizar veículo",
        });
        return error.response;
      });
  }
}

export default VehiclesService;
